import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/public/locales/{{lng}}/{{ns}}.json",
    },
    fallbackLng: "en",
    // t() returns the key string (never null) for missing/null values, matching
    // the CustomTypeOptions augmentation in types/react-i18next.d.ts so t() is
    // typed as `string`.
    returnNull: false,
  });

i18n.changeLanguage("en");

export default i18n;
